/**
 * Generic object used to carry information between different
 * layers in the application
 */
export class Message {
  /**
   * @param {int}    type     0 - failure | 1 - success | 2 - info
   * @param {int}    html     0 - text | 1 - html
   * @param {string} value    value to be displayed
   * @param {object} metaData extra data
   */
  constructor(type, html, value, metaData = {}) {
    this.type = type;
    this.html = html;
    this.value = value;
    this.metaData = metaData;
  }

  get() {
    return {
      type: this.type,
      html: this.html,
      value: this.value,
      metaData: this.metaData
    };
  }
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/message.js